exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ShowResultsBar_showResultsContainer__3dn55{display:-webkit-flex;display:flex}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq{display:-webkit-flex;display:flex;padding:10px 15px;-webkit-align-items:center;align-items:center;cursor:pointer}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq .ShowResultsBar_showResults__text__3PP7M{font-size:14px;color:#42b4e6}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq .ShowResultsBar_showResults__icon__7X6Yj{position:relative;top:1px;margin-left:5px}@media only screen and (min-width:961px){.ShowResultsBar_showResultsContainer__3dn55{display:-webkit-flex;display:flex}.ShowResultsBar_showResultsContainer__3dn55:hover{background-color:#f5f5f5;cursor:pointer}.ShowResultsBar_showResultsContainer__3dn55:hover .ShowResultsBar_showResults__text__3PP7M{text-decoration:underline}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq{display:-webkit-flex;display:flex;padding:10px;-webkit-align-items:center;align-items:center;cursor:pointer}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq .ShowResultsBar_showResults__text__3PP7M{font-size:14px;color:#42b4e6}.ShowResultsBar_showResultsContainer__3dn55 .ShowResultsBar_showResults__2O1uq .ShowResultsBar_showResults__icon__7X6Yj{position:relative;top:1px;margin-left:5px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"showResultsContainer": "ShowResultsBar_showResultsContainer__3dn55",
	"showResults": "ShowResultsBar_showResults__2O1uq",
	"showResults__text": "ShowResultsBar_showResults__text__3PP7M",
	"showResults__icon": "ShowResultsBar_showResults__icon__7X6Yj"
};